import { format, parseISO, set } from 'date-fns'

export const dateFormatHelper = (date: Date | string): string => {
  let dateObj = typeof date === 'string' ? parseISO(date) : date
  dateObj = set(dateObj, { hours: 0, minutes: 0, seconds: 0, milliseconds: 0 })
  let timeWithoutDifference = new Date(dateObj.valueOf() - dateObj.getTimezoneOffset() * 60 * 1000)
  return format(timeWithoutDifference, "yyyy-MM-dd'T'HH:mm:ssXXX").replace(/Z/, '+00:00') //replace - to handle the problem with time zone 00
}
